import axios from 'axios';
import config from '../config';

export const api = axios.create({
	baseURL: config.host.api,
	timeout: 10000 // 10 seconds
});


// WEBPACK FOOTER //
// ./src/api/api.js